import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "secondary-font gap-4 mt-2 mb-6" }
const _hoisted_3 = { class: "s20 widget pt-8 pb-8" }
const _hoisted_4 = {
  key: 0,
  class: "s10 mt--5-5 flex-right"
}
const _hoisted_5 = {
  key: 1,
  class: "s10 mt--5-5 flex-right"
}
const _hoisted_6 = { class: "flex px-6" }
const _hoisted_7 = { class: "s4_mobile" }
const _hoisted_8 = { class: "my-2" }
const _hoisted_9 = { class: "font-normal my-2" }
const _hoisted_10 = { class: "s9_mobile px-8" }
const _hoisted_11 = { class: "text-xl text-grey-600 my-2" }
const _hoisted_12 = { class: "text-primary-color" }
const _hoisted_13 = { class: "text-xl text-grey-600 my-2" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "text-xl text-grey-600 my-2" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "text-xl text-grey-600 my-2" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "text-xl text-grey-600 my-2" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "table separator skin2 selection" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  class: "square-lg px-3 py-3",
  style: {"background-color":"rgb(var(--color-success-rgb), 0.1)"}
}
const _hoisted_24 = ["src"]

import { formatAmount, formatDate } from '@/utils';
    import { useRoute } from 'vue-router';
    import { onMounted, reactive, ref } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import axios from 'axios';
    import MarketCommandeRejectModal from './modals/MarketCommandeRejectModal.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCommandesDetailsView',
  setup(__props) {

    const route = useRoute();
    const commande = reactive({
        num_commande: "",
        created_at: "",
        sous_total: 0,
        total: 0,
        statut: "",
        user: {
            nom: "",
            prenom: "",
            email: "",
        },
        produits: [] as any[],
    });
    const loading = ref(false);
    const errorMessage = ref('');
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const rejectModalRef = ref<InstanceType<typeof MarketCommandeRejectModal> | null>(null);

    onMounted(() => {
        Object.assign(commande, route.meta.commande);
    });

    async function doValidateCommande(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Commande Market", "Voulez-vous vraiment valider cette commande ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                const result = await axios.post(`/backoffice/market-commandes/validate/${item.id}`, {});
                Object.assign(commande, result.data);
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    async function doRejectCommande(item: any) {
        const result: any = await rejectModalRef.value?.open(item);
        if (result) {
            Object.assign(commande, result);
        }
    }

    async function doStartDelivery(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Commande Market", "Confirmez-vous le début de la livraison de cette commande ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                const result = await axios.post(`/backoffice/market-commandes/start-delivery/${item.id}`, {});
                Object.assign(commande, result.data);
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("h2", _hoisted_2, " Détails commande - " + _toDisplayString(commande.num_commande), 1),
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "s10" }, "   ", -1)),
      (commande.statut == 'pending')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_custom_button, {
              loading: loading.value,
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (doValidateCommande(commande)))
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("img", {
                  src: "/icons/icon-actif.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createTextVNode(" Valider la commande ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_custom_button, {
              loading: loading.value,
              class: "btn danger mr-4",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (doRejectCommande(commande)))
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: "/icons/icon-danger.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createTextVNode(" Rejeter la commande ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true),
      (commande.statut == 'confirmed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_custom_button, {
              loading: loading.value,
              class: "btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (doStartDelivery(commande)))
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: "/icons/icon-actif.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createTextVNode(" Procéder à la livraison ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "s3_mobile px-4" }, [
          _createElementVNode("div", { class: "rounded-100 overflow-hidden item active" }, [
            _createElementVNode("img", {
              src: '/assets/users/300w/user2.jpg',
              width: "100%"
            })
          ])
        ], -1)),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "s1_mobile flex-center" }, " ", -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(commande.user.nom + ' ' + commande.user.prenom), 1),
          _createElementVNode("h6", _hoisted_9, _toDisplayString(commande.user.email), 1)
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "s1_mobile flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-90p" })
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[6] || (_cache[6] = _createTextVNode("Num Commande: ", -1)),
            _createElementVNode("div", _hoisted_12, _toDisplayString(commande.num_commande), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[7] || (_cache[7] = _createTextVNode("Date Commande: ", -1)),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(formatDate)(commande.created_at)), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[8] || (_cache[8] = _createTextVNode("Sous total: ", -1)),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(formatAmount)(commande.sous_total)), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[9] || (_cache[9] = _createTextVNode("Total: ", -1)),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(formatAmount)(commande.total)), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[10] || (_cache[10] = _createTextVNode("Status: ", -1)),
            _createElementVNode("div", _hoisted_20, _toDisplayString(commande.statut), 1)
          ])
        ])
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
      _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "s20 my-0 hr2 opacity-1" }, null, -1)),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
      _createElementVNode("table", _hoisted_21, [
        _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { width: "80px" }),
            _createElementVNode("th", null, "Produit"),
            _createElementVNode("th", null, "Prix unitaire"),
            _createElementVNode("th", null, "Quantité"),
            _createElementVNode("th", null, "Total")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (commande.produits.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[14] || (_cache[14] = [
                _createElementVNode("td", { colspan: "5" }, [
                  _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun élément trouvé")
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commande.produits, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "text-grey-700 over-effect",
              key: 'item_' + index
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("img", {
                    src: item.produit.image_url ? item.produit.image_url : '/icons/icon-securite-role.svg',
                    width: "100%"
                  }, null, 8, _hoisted_24)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("h6", null, _toDisplayString(item.produit.nom), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("h6", null, _toDisplayString(_unref(formatAmount)(item.montant_apres_remises)), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("h6", null, _toDisplayString(_unref(formatAmount)(item.quantite)), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("h6", null, _toDisplayString(_unref(formatAmount)(item.total)), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512),
    _createVNode(MarketCommandeRejectModal, {
      ref_key: "rejectModalRef",
      ref: rejectModalRef
    }, null, 512)
  ]))
}
}

})